import { render, staticRenderFns } from "./EditarSituacionRevista.vue?vue&type=template&id=27f01568&"
import script from "./EditarSituacionRevista.vue?vue&type=script&lang=js&"
export * from "./EditarSituacionRevista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports